import config from 'constants/config'
import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import { getAgentHubItemTotalCommissionAmount } from 'lib/payment/agentHubUtils'
import { floatify } from 'lib/maths/mathUtils'

// The promo service rounds a blended percentage per line. Use the quoted item
// amounts instead so the displayed deduction and funded payment agree to the cent.
const getCommissionPaymentAmount = createSelector(
  (state: App.State) => state.checkout.commission,
  (state: App.State) => state.checkout.commissionData,
  (commission, commissionData): number => {
    if (!commission) return 0

    if (!config.agentHub.isEnabled) return floatify(commission.discountTotal ?? 0)

    const items = Object.values(commissionData?.itemsCommission ?? {})
    if (!items.length) return floatify(commission.discountTotal ?? 0)

    // Preserve the payment builder's per-item incentive handling.
    return floatify(sum(items, getAgentHubItemTotalCommissionAmount))
  },
)

export default getCommissionPaymentAmount
